export const redGetters = {
    isCartFilled: () => false,
    currentCouponCode: (state) => { var _a, _b; return (_b = (_a = state.cart) === null || _a === void 0 ? void 0 : _a.coupon_code) !== null && _b !== void 0 ? _b : ''; },
};
